import ToastService from "./Toast.Service";

class ProductService {
  async getAll(page = 1) {
    return await fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/products?" +
        new URLSearchParams({
          limit: 20,
          page: page,
          category: router.query.category || "",
          query: router.query.query || "",
          dimension1: router.query.dimension1 || "",
          dimension2: router.query.dimension2 || "",
          dimension3: router.query.dimension3 || "",
          color: router.query.color || "",
          pitch: router.query.pitch || "",
          flowering_period: router.query.flowering_period || "",
          shape: router.query.shape || "",
          height: router.query.height || "",
          sort: router.query.sort || "",
          order: router.query.order || "",
          variant: router.query.variant || "",
        }),
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    ).then((response) => response.json());
  }

    async toggleFavorite(jwtToken, uid, isFavorite, ) {
        const foo = !isFavorite;

        const promise = fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/products/" +
            uid +
            `/favorite`,
            {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({favorite: foo}),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
            });

        ToastService.promiseToast(promise);
    };
}

export default new ProductService();
